//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  cancelKsCjfh,
  queryKsCjfhCardList,
} from '@/https/otherApplication'
import {
  danger,
  success,
} from '@/utils/notify.js'
import checkNoPassImg from '@/assets/img/check_no_pass.png'
import checkPassImg from '@/assets/img/check_pass.png'
import checkIngImg from '@/assets/img/check_ing.png'
import noSubmitImg from '@/assets/img/no_submit.png'
import TCardItem from '@/TShareComponent/TCardItem'
import { checkFilterTool } from '@/constant/dict.js'

export default {
  components: { TCardItem },

  props: {
    code: {
      type: [
        String,
        Number,
      ],
    },
  },

  data () {
    return {
      checkFilterTool,
      list: [],
      wishNum: 0,
      statusMap: {
        0: noSubmitImg,
        1: checkIngImg,
        2: checkPassImg,
        3: checkNoPassImg,
      },
      msg: '没有查询到审核通过的报名信息',
      loading: false,
    }
  },

  computed: {},

  created () {
    this.setCardList()
  },

  methods: {
    async setCardList () {
      this.loading = true
      const { data } = await queryKsCjfhCardList({})

      this.list = data || []
      this.loading = false
    },

    canFill (item) {
      const kssj = new Date(item.kssj.replace(/-/g, '/'))
      const jzsj = new Date(item.jzsj.replace(/-/g, '/'))
      const now = new Date().getTime()

      return now <= jzsj.getTime() && now >= kssj
    },

    goEnrollDetail (enroll) {
      this.$router.push({
        path: '/reviewApplicationDetail',
        query: { pcdm: enroll.pcdm },
      })
    },

    async handlerRecycle (item) {
      const { code, message } = await cancelKsCjfh({ wid: item.sqWid })

      if (+code === 0) {
        this.setCardList()
        success('操作成功')
      } else {
        danger(message)
      }
    },

    handlerEnroll (enroll) {
      this.$router.push({
        path: '/startReviewApplication',
        query: {
          pcdm: enroll.pcdm,
          code: this.code,
          wid: enroll.wid,
        },
      })
    },
  },
}
